import { FaInstagram, FaFacebookF, FaTwitter } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../../assets/jainlogos.png";
import bg from "../../assets/jainwedding.png";

const Footer = () => {
  return (
    <footer
      className="relative text-white"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/70"></div>

      {/* Footer Content */}
      <div className="relative max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-4 gap-10 z-10">
        {/* Logo + Thought */}
        <div className="md:col-span-2 flex flex-col items-start space-y-4">
          <img
            src={logo}
            alt="Matrimony Logo"
            className="h-14 rounded-lg shadow-lg bg-white p-1"
          />
          <p className="italic text-gray-200 font-medium leading-relaxed">
            “Marriage is not just about finding the right person, it’s about
            being the right person.”
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-semibold text-amber-400 mb-4 border-b border-amber-400 pb-1 inline-block">
            Quick Links
          </h3>
          <ul className="space-y-2">
            {[
              { name: "About Us", link: "/about" },
              { name: "Privacy Policy", link: "/privacy-policy" },
              { name: "Terms & Conditions", link: "/termandcondition" },
              { name: "Contact Us", link: "/contact-us" },
            ].map((item) => (
              <li key={item.name}>
                <Link
                  to={item.link}
                  target="_blank"
                  className="hover:text-amber-400 text-white text-decoration-none transition duration-200"
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Social Links */}
        <div>
          <h3 className="text-lg font-semibold text-amber-400 mb-4 border-b border-amber-400 pb-1 inline-block">
            Connect with us
          </h3>
          <div className="flex space-x-4 ">
            {[
              {
                href: "https://instagram.com",
                label: "Instagram",
                icon: <FaInstagram size={20} />,
              },
              {
                href: "https://facebook.com",
                label: "Facebook",
                icon: <FaFacebookF size={20} />,
              },
              {
                href: "https://twitter.com",
                label: "Twitter",
                icon: <FaTwitter size={20} />,
              },
            ].map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                className="p-3 bg-white/10 backdrop-white-md rounded-full hover:bg-amber-400 hover:text-black transition transform hover:scale-110 shadow-lg"
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="relative z-10 text-center text-xs text-gray-300 py-4 border-t border-white/20 bg-black/40">
        © {new Date().getFullYear()}{" "}
        <span className="text-amber-400 font-semibold">Jain Var Vadhu</span>. All
        rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
